import { Divider } from 'antd';
import styled from 'styled-components';

export const DividerStyled = styled(Divider)`
	border-color: #d9d9d9;
`;
